import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '@docpath/linces-angular-components/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { EndPoints } from '../../../constants/end-points';

@Component({
  selector: 'app-log',
  templateUrl: './log.component.html',
  standalone: true,
  imports: [TranslateModule, FontAwesomeModule]
})
export class LogComponent implements OnInit {

  readonly relativeUrl = `${EndPoints.ENDPOINT_WEB_API}/${EndPoints.ENDPOINT_STATISTICS}/${EndPoints.ENDPOINT_STATISTICS_LOG}`;

  icon = faFileInvoice;
  title: string;

  logContent: string;
  logEmptyMessage: string;

  private readonly route = inject(ActivatedRoute);
  private readonly httpService = inject(HttpService);
  private readonly translateService = inject(TranslateService);

  constructor() {
    this.title = '';
    this.logContent = '';
    this.logEmptyMessage = '';
  }

  ngOnInit(): void {
    const idJob = this.route.snapshot.paramMap.get('idJob');
    const dgeId = this.route.snapshot.paramMap.get('dgeId');
    if (idJob && dgeId) {
      this.loadTitle(idJob);
      this.loadLog(idJob, dgeId);
      this.translateService.onLangChange.subscribe(() => {
        this.loadTitle(idJob);
      });
    }
  }


  loadLog(idJob: string, idDGE: string) {
    this.httpService.get({
      relativeUrl: `${this.relativeUrl}`,
      queryParameters: { idJob, idDGE },
      loading: true,
      suscribe: response => {
        const logContentBase64 = response.result as unknown as string;
        if (logContentBase64) {
          this.logContent = decodeURIComponent(atob(logContentBase64));
        } else {
          this.logEmptyMessage = 'log.empty-message';
        }
      }
    });
  }

  private loadTitle(idJob: string) {
    const parameterObjects: { [key: string]: string; } = {};
    parameterObjects[`param${0}`] = idJob;
    this.translateService.get('log.title', parameterObjects).subscribe(
      (title: string) => {
        this.title = title;
      }
    );
  }
}
